import type { ReactNode } from "react";

interface FieldDisplayProps {
  label: string;
  children: ReactNode;
}

/** Labeled key-value display used in the tracking dashboard's detail rows. */
export function FieldDisplay({ label, children }: FieldDisplayProps) {
  return (
    <div>
      <dt className="text-muted-foreground text-[10px] leading-none font-medium tracking-wider uppercase">
        {label}
      </dt>
      <dd className="mt-0.5 text-xs leading-tight font-medium">{children}</dd>
    </div>
  );
}
